import { useState } from 'react';
import { PrimaryButton } from '../components/Button';
import API_ROOT from '../config';

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const key = await fetch(`${API_ROOT}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });
      if (!key.ok) {
        setMessage('Login failed: ' + key.statusText);
        return;
      }
      const keyData = await key.json();
      setMessage('');

      if (onLogin) {
        onLogin({ username, accessToken: keyData.accessToken, refreshToken: keyData.refreshToken });
      }
    }
    catch (error) {
      setMessage('Login failed: ' + error.message);
    }
  };
  
  return (
    <div className='login-page'>
    <form onSubmit={handleSubmit}>
      <input
        className="form-control my-2"
        type="text"
        placeholder="Username"
        value={username}
        onChange={e => setUsername(e.target.value)}
      />
      <input
        className="form-control my-2"
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
      />
      <PrimaryButton type="submit">Log in</PrimaryButton>
      {message && <div className="alert alert-danger m-2">{message}</div>}

    </form>
      </div>
  );
}

export default LoginPage;